import React, { useRef } from 'react'
import { useInterval } from '../Hooks';

export type TimerTextProps = {
  expireAt?: number | string | Date | null
  onTimeout?: () => any
}
const normalizeTime = (value?: string | number | Date | null) => {
  switch (typeof value) {
    case 'string':
      return new Date(value).getTime()
    case 'number':
      return value
  }
  if (value instanceof Date) {
    return value.getTime()
  }
  return
}
const ONE_MINUTE = 60 * 1000;
const formatTime = (time: number) => {
  if (typeof time !== 'number' || time <= 0) {
    return `0 мин. 0 сек.`
  }
  const min = Math.floor(time / ONE_MINUTE)
  time -= min * ONE_MINUTE
  const sec = Math.floor(time / 1000)
  return `${min} мин. ${sec} сек.`
}
export const TimerText: React.FC<TimerTextProps> = (props) => {
  const called = useRef(false)
  const now = useInterval(500)
  const expireAt = normalizeTime(props.expireAt)
  const time = typeof expireAt !== 'number' ? 0 : expireAt - now
  if (time <= 0 && props.expireAt && props.onTimeout && !called.current) {
    called.current = true
    props.onTimeout()
  }
  const text = formatTime(time)
  return <span>{text}</span>
}